var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{attrs:{"fields":[
    {
      key: 'usuario',
      label: _vm.$t('Nome'),
    },
    {
      key: 'parentesco_rf',
      label: _vm.$t('Parentesco RF'),
    },
    {
      key: 'descricao',
      label: _vm.$t('Descrição'),
    },
    {
      key: 'actions',
      label: '',
      class: 'text-right',
      thStyle: { width: '95px', minWidth: '95px' },
    },
  ],"items":_vm.relacionados,"striped":"","hover":"","show-empty":"","small":"","outlined":"","stacked":"md","table-class":"mb-3","responsive":true},scopedSlots:_vm._u([{key:"cell(usuario)",fn:function(data){return [(data.item.usuario)?_c('strong',[_vm._v("\n      "+_vm._s(data.item.usuario.nome_completo)+"\n    ")]):_vm._e()]}},{key:"cell(parentesco_rf)",fn:function(data){return [_vm._v(" "+_vm._s(data.item.parentesco_rf)+" ")]}},{key:"cell(descricao)",fn:function(data){return [_c('strong',[_vm._v(" "+_vm._s(data.item.descricao))])]}},{key:"cell()",fn:function(data){return [_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"px-2 mb-0 btn-desvincular",attrs:{"title":_vm.$t('Desvincular'),"variant":"warning","size":"xs","data-style":"zoom-in","type":"button","id":'btndesvincular' + data.item.id},on:{"click":function($event){$event.preventDefault();return _vm.removerRelacionado(data.item.id, data.index)}}},[_c('i',{staticClass:"fas fa-unlink"})])]}},{key:"empty",fn:function(scope){return [_c('div',{staticClass:"text-center my-5"},[_c('img',{staticClass:"mb-5",staticStyle:{"max-height":"165px"},attrs:{"alt":_vm.$t('No results'),"src":"/img/icons/robot.svg"}}),_vm._v(" "),_c('h3',{staticClass:"bold"},[_vm._v(_vm._s(_vm.$t("No records found")))])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }